// extracted by mini-css-extract-plugin
export var active = "_if-2";
export var recordingDot = "_if-1";
export var recordingIndicator = "_if-0";